import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { HolidayCalendar, HolidayCalendarCreate, HolidayCalendarFilter } from '../data/holidayCalendar';

export function createHolidayCalendarService(client: AxiosInstance) {
  return createCrudService<HolidayCalendar, HolidayCalendarCreate, HolidayCalendarFilter>(
    client,
    '/hrm/HolidayCalendar',
    'id',
  );
}

export type HolidayCalendarService = CrudService<HolidayCalendar, HolidayCalendarCreate, HolidayCalendarFilter>;
